/**
 * Common validation message helpers.
 * Pattern matches backend `resources/lang/ja/validation.php`:
 *   required  → ':attributeは必須です。'
 *   integer   → ':attributeは整数にしてください。'
 *   max.string → ':attributeは:max文字以下にしてください。'
 */

export const requiredMsg = (field: string) => `${field}は必須です。`;
export const integerMsg = (field: string) => `${field}は整数にしてください。`;
export const maxStringMsg = (field: string, max: number) =>
  `${field}は${max}文字以下にしてください。`;
export const minArrayMsg = (label: string, min: number) =>
  `${label}は${min}件以上必要です。`;
